import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	height: 100%;
	display: grid;
	gap: 1.5rem;
	grid-template-columns: 0.6fr 2fr;
	grid-template-rows: 100%;
	align-items: center;
	overflow: hidden;

	box-sizing: content-box;

	@media (max-width: 1600px) {
		grid-template-columns: 0.8fr 2fr;
	}

	@media (max-width: 1200px) {
		grid-template-columns: 1fr 2fr;
	}

	@media (max-width: 1100px) {
		height: 100%;
		display: flex;
		flex-direction: column;
		gap: 1.5rem;
		margin-top: 1.5rem;
		overflow: auto;
	}
`;

export const loadBox = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 1rem;
	border-radius: 5px;
	background-color: ${color.interface.white};
`;
